import React, { useEffect, useState } from "react";
import { useAlert } from "react-alert";
import { Link } from "react-router-dom";
import dataServices from "../../apiServices/data.services";
import Loader from "../../components/Loader/Loader";
import { handleValidationError, showAlert } from "../../components/CommonFunctions";
import { Can } from "../../context/AuthProvider";

const Subscriptions = () => {
  const [subscriptions, setSubscriptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const alert = useAlert();

  useEffect(() => {
    setLoading(true);
    dataServices
      .getSubscriptions()
      .then((res) => {
        if (res.status === 200) {
          setSubscriptions(res.data);
        }
      })
      .catch((err) => {
        alert.error(handleValidationError(err));
      })
      .finally(() => setLoading(false));
  }, [alert]);

  const handleDelete = (id) => {
    dataServices
      .deleteSubscription(id)
      .then((res) => {
        if (res.status === 200 || res.status === 204) {
          setSubscriptions(subscriptions.filter((sub) => sub.id !== id));
          alert.success("Subscription deleted successfully");
        }
      })
      .catch((err) => {
        alert.error(handleValidationError(err));
      });
  };

  return (
    <div className="content-wrapper">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h6 className="mb-2 pb-1 px-3 fw-bold text-black">Subscriptions</h6>
        <Can I="add" this="Subscription">
          <Link to="/add-subscription" className="btn btn-primary">
            Add Subscription
          </Link>
        </Can>
      </div>
      <Can I="list" this="Subscription">
        <div className="list">
          {subscriptions.length > 0 ? (
            subscriptions.map((sub) => (
              <div className="list-item d-flex justify-content-between align-items-center" key={sub.id}>
                <div className="w-100">
                  <div className="d-flex justify-content-between align-items-start">
                    <div>
                      <h6 className="mb-1 fs-14">{sub.name || `#${sub.id}`}</h6>
                      <small className="text-muted">{sub.description || "No description"}</small>
                      <br />
                      <strong>Plan:</strong> {sub.plan?.name || sub.plan_name || "N/A"} | <strong>Start Date:</strong> {sub.start_date || "N/A"}
                      {sub.end_date ? <> | <strong>End Date:</strong> {sub.end_date}</> : null}
                    </div>
                    <small className={`badge ${sub.status === "active" ? "bg-success" : "bg-secondary"}`}>
                      {sub.status || "inactive"}
                    </small>
                  </div>
                  <div className="mt-2 d-flex gap-2">
                    <Can I="read" this="Subscription">
                      <Link className="btn btn-sm btn-outline-info" to={`/subscription/${sub.id}`}>
                        Details
                      </Link>
                    </Can>
                    <Can I="edit" this="Subscription">
                      <Link className="btn btn-sm btn-outline-primary" to={`/edit-subscription/${sub.id}`}>
                        Edit
                      </Link>
                    </Can>
                    <Can I="delete" this="Subscription">
                      <button className="btn btn-sm btn-outline-danger" onClick={() => showAlert("Subscription", handleDelete, sub.id)}>
                        Delete
                      </button>
                    </Can>
                  </div>
                </div>
              </div>
            ))
          ) : loading ? (
            <Loader />
          ) : (
            <p className="px-3">No subscriptions found.</p>
          )}
        </div>
      </Can>
    </div>
  );
};

export default Subscriptions;
